export default __webpack_public_path__ + "static/media/480_business05-en-mobile.83b04d93.png";